module.exports = __webpack_public_path__ + "app-static/img/icon_wx.9e7169e6.png";